import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, Facebook, Instagram, Twitter, ShieldCheck, Truck, Award, Headphones } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-[#0a2c56] text-slate-200 mt-16">
      {/* Trust badges */}
      <div className="border-b border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-8 grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { icon: Truck, title: "Fast Shipping", sub: "Free on orders $75+" },
            { icon: ShieldCheck, title: "Secure Checkout", sub: "256-bit SSL & Square" },
            { icon: Award, title: "Trusted Brands", sub: "Medline • 3M • Convatec" },
            { icon: Headphones, title: "Expert Support", sub: "Mon–Fri 9a–6p EST" },
          ].map(({ icon: Icon, title, sub }) => (
            <div key={title} className="flex items-center gap-3">
              <div className="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center shrink-0">
                <Icon className="w-5 h-5 text-amber-400" />
              </div>
              <div>
                <div className="font-semibold text-white text-sm">{title}</div>
                <div className="text-xs text-slate-300">{sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center">
              <span className="text-white font-black text-lg">iZ</span>
            </div>
            <div>
              <div className="font-black text-white text-lg">IZZI MEDICAL SUPPLIES</div>
              <div className="text-[10px] uppercase tracking-widest text-slate-400">Quality Medical Products</div>
            </div>
          </div>
          <p className="text-sm text-slate-300 leading-relaxed max-w-md">
            Izzi Medical Supplies is your trusted partner for professional-grade
            medical equipment and everyday healthcare essentials. Family-owned
            and proudly serving customers nationwide.
          </p>
          <ul className="mt-6 space-y-2 text-sm">
            <li className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-amber-400" /> 1871 Woodslee Dr, Troy, MI 48083
            </li>
            <li className="flex items-center gap-2">
              <Phone className="w-4 h-4 text-amber-400" />
              <a className="hover:text-amber-300" href="tel:18882869244">1 (888) 286-9244</a>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-amber-400" />
              <a className="hover:text-amber-300" href="mailto:support@izzimedicalsupplies.com">support@izzimedicalsupplies.com</a>
            </li>
          </ul>
          <div className="flex items-center gap-3 mt-6">
            <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
              <Facebook className="w-4 h-4" />
            </a>
            <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
            <a href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors">
              <Twitter className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-bold text-white uppercase text-xs tracking-widest mb-4">Shop</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/shop/incontinence" className="hover:text-amber-300">Incontinence</Link></li>
            <li><Link to="/shop/wound-care" className="hover:text-amber-300">Wound Care</Link></li>
            <li><Link to="/shop/mobility-aids" className="hover:text-amber-300">Mobility Aids</Link></li>
            <li><Link to="/shop/oxygen-concentrators" className="hover:text-amber-300">Oxygen</Link></li>
            <li><Link to="/shop/exam-gloves" className="hover:text-amber-300">Exam Gloves</Link></li>
            <li><Link to="/shop" className="hover:text-amber-300">All Products</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-bold text-white uppercase text-xs tracking-widest mb-4">Customer Service</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/account/orders" className="hover:text-amber-300">Track Order</Link></li>
            <li><Link to="/contact" className="hover:text-amber-300">Contact Us</Link></li>
            <li><Link to="/shipping" className="hover:text-amber-300">Shipping Info</Link></li>
            <li><Link to="/returns" className="hover:text-amber-300">Returns Policy</Link></li>
            <li><Link to="/privacy" className="hover:text-amber-300">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-amber-300">Terms of Service</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} Izzi Medical Supplies. All rights reserved.</div>
          <div className="flex items-center gap-3">
            <span>We accept:</span>
            <span className="px-2 py-1 rounded bg-white/10 font-semibold">VISA</span>
            <span className="px-2 py-1 rounded bg-white/10 font-semibold">MC</span>
            <span className="px-2 py-1 rounded bg-white/10 font-semibold">AMEX</span>
            <span className="px-2 py-1 rounded bg-white/10 font-semibold">DISC</span>
            <span className="px-2 py-1 rounded bg-amber-500 text-slate-900 font-bold">Square</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
